import ContentImage from './ContentImage'

const fallbacks = ['obra-tijuana', 'puente-reynosa', 'perforadora-vertical', 'maquinaria-panoramica']

export default function ContentArchive({ entries, className = '' }) {
  return (
    <div className={`content-archive ${className}`}>
      {entries.map((entry, index) => (
        <a className="content-card" href={entry.path} key={entry.slug} data-reveal data-analytics-event="select_content" data-analytics-location="content_archive" data-analytics-content-type={entry.kind} data-analytics-content-id={entry.slug} data-analytics-label={entry.title}>
          <ContentImage image={entry.images[0]} fallback={fallbacks[index % fallbacks.length]} alt={entry.title} sizes="(min-width: 1100px) 33vw, (min-width: 700px) 50vw, 100vw" />
          <div><span>{entry.category} / {String(index + 1).padStart(2, '0')}</span><h2>{entry.title}</h2><p>{entry.description}</p><i>Leer caso ↗</i></div>
        </a>
      ))}
    </div>
  )
}
